var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'user-avatar': true,
    'candidate-avatar': _vm.isCandidate,
    'status-online': !_vm.isCandidate
}},[_c('img',{attrs:{"src":_vm.computedImgUrl,"alt":""},on:{"error":_vm.handleImageError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }